// React
import { useContext } from "react"

// UI
import { cn } from "@/lib/utils"
import { Card } from "@/components/Card"
import { Heading } from "@/components/Typography"
import { Button } from "@/components/Button"

// Context
import { RedirectContext } from "@/context/redirectContext"

// Translations
import { useTrans } from "@/i18n"

// Environment variables
import { EXTERNAL_PLATFORM_ZONHUB_INVESTMENT } from "@/lib/env"

// Icons
import { FiChevronDown, FiChevronUp } from "@/lib/icons"

// Redux
import { useDispatch, useSelector } from "@/state/StateProvider"
import {
	UserPreferencesState,
	setShowInvestmentBanner,
} from "@/state/features/userPreferencesSlice"

/**
 * InvestmentOpportunityBanner
 * @returns
 */
export function InvestmentOpportunityBanner({
	className = "",
}: {
	className?: any
}) {
	// Translations
	const t = useTrans("investments")

	// Context
	const { redirect } = useContext(RedirectContext)

	// Redux state
	const dispatch = useDispatch()
	const showInvestmentBanner = useSelector(
		({ userPreferences }: { userPreferences: UserPreferencesState }) =>
			userPreferences.showInvestmentBanner,
	)

	return (
		<Card className={cn("relative w-full bg-yellow-50", className)}>
			{/** Minimize/Maximize button */}
			<button
				onClick={() =>
					dispatch(setShowInvestmentBanner(!showInvestmentBanner))
				}
				className="absolute right-4 top-4 text-gray-400 hover:text-gray-600"
				aria-label={
					showInvestmentBanner ? "Expand banner" : "Minimize banner"
				}
			>
				{showInvestmentBanner ? (
					<FiChevronDown className="size-5" />
				) : (
					<FiChevronUp className="size-5" />
				)}
			</button>

			<Heading as="h2" styleAs="h5" className="sm:truncate">
				{t("investments:investments.banner.opportunities.title")}
			</Heading>

			{!showInvestmentBanner && (
				<>
					<div className="my-4">
						<p className="text-sm text-gray-500">
							{t(
								"investments:investments.banner.opportunities.copy",
							)}
						</p>
					</div>
					<Button
						className="inline-block"
						onClick={() => {
							redirect(EXTERNAL_PLATFORM_ZONHUB_INVESTMENT)
						}}
					>
						{t("investments:investments.banner.opportunities.cta")}
					</Button>
				</>
			)}
		</Card>
	)
}
